import { login, logout, getInfo } from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'

const user = {
  state: {
    token: getToken(),
    name: '',
    avatar: '',
    roles: []
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      const username = userInfo.username.trim()
      return new Promise((resolve, reject) => {
        login(username, userInfo.password).then(response => {
          const data = response.data
          // 后端返回格式: { token: "jwt_token", tokenHead: "Bearer " }
          const tokenStr = data.tokenHead + data.token
          setToken(tokenStr)
          commit('SET_TOKEN', tokenStr)
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit, state }) {
      return new Promise((resolve, reject) => {
        console.log('=== 开始GetInfo ===');
        console.log('当前state.roles:', state.roles);

        getInfo().then(response => {
          console.log('=== 前端GetInfo调试 ===');
          console.log('完整响应:', response);
          console.log('response.data:', response.data);

          // 后端返回格式: { code: 200, message: "操作成功", data: { username, email, icon, roles, menus } }
          const data = response.data.data || response.data;
          console.log('提取的数据:', data);

          // 强制设置roles，避免空数组导致循环
          let roles = data.roles;
          console.log('后端返回的roles:', roles);
          console.log('roles类型:', typeof roles);
          console.log('roles是否为数组:', Array.isArray(roles));
          console.log('roles长度:', roles ? roles.length : 'undefined');

          // 如果roles为空或不存在，强制设置为admin
          if (!roles || !Array.isArray(roles) || roles.length === 0) {
            console.log('roles为空，强制设置为admin');
            roles = ['admin'];
          }
          console.log('最终设置的roles:', roles);

          // 更新状态
          commit('SET_ROLES', roles);
          commit('SET_NAME', data.username);
          commit('SET_AVATAR', data.icon);

          console.log('更新后的state.roles:', roles);
          console.log('更新后的state.roles长度:', roles.length);

          // 返回包含menus的完整数据
          const result = {
            ...response,
            data: {
              ...data,
              menus: data.menus || [],
              username: data.username
            }
          };
          console.log('最终返回结果:', result);
          resolve(result)
        }).catch(error => {
          console.error('GetInfo错误:', error);
          reject(error)
        })
      })
    },

    // 登出
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token).then(() => {
          commit('SET_TOKEN', '')
          commit('SET_ROLES', [])
          removeToken()
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js